// Services
import ApiService from "../services/api.service"

const model = 'tasks'

export default class TasksService {
  static list(search = false, limit = 10, skip = 0, fields = '', filter = false) {
    const sort = 'deadline'
    if (search && search !== '') search = `{"title": "regex:${search}"}`
    return ApiService.list(model, { search, filter, limit, skip, fields, sort}).then(response => response.data)
  }

  static post(data = {}) {
    return ApiService.post(model, data).then(response => response)
  }
  
  static patch(taskId, patch = {}) {
    return ApiService.patch(`${model}/${taskId}`, patch).then(response => response) 
  }
  
  static delete(taskId) {
    return ApiService.delete(`${model}/${taskId}`).then(response => response) 
  } 
}